import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import './trips.css'
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import UploadOperatorImages from "./UploadOperatorImages";
import { IMG_SERVER_URL, SERVER_URL } from "../../ServerUrl";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";



function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "50%", background: "#FFE26A" }}
            onClick={onClick}
        >
            <FaAngleRight className="rightArrowSlider" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "flex", justifyContent: "center", alignItems: "center", background: "#FFE26A", borderRadius: "50%", }}
            onClick={onClick}
        >
            <FaAngleLeft className="rightArrowSlider" />
        </div>
    );
}


const OperatorPictursSlider = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [operatorsImages, setOperatorsImages] = useState([]);
    const operatorId = useSelector((state) => state?.auth?.operator?._id);
    const operatorImagesFromRedux = useSelector((state) => state?.auth?.operator?.images);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    useEffect(() => {
        if (operatorImagesFromRedux) {
            setOperatorsImages(operatorImagesFromRedux);
        }
    }, [operatorImagesFromRedux]);

    const updateOperatorsImages = (newImage) => {
        setOperatorsImages(newImage);
    };


    console.log(operatorsImages, "operatorsImages")

    const DeletePhoto = async () => {
        const auth = sessionStorage.getItem("token");

        // Show confirmation dialog
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                // Step 1: Find the index of the selected image
                const imageIndex = operatorsImages.findIndex((image) => image === selectedImage);

                if (imageIndex === -1) {
                    throw new Error("Image not found in the array");
                }

                // Step 2: Send the index to the backend
                const res = await axios.patch(
                    `${SERVER_URL}/operator/${operatorId}/delete-image`,
                    { imageIndex }, // Send the index of the image to delete
                    {
                        headers: {
                            "Content-Type": "application/json", // Use JSON for sending data
                            auth: `${auth}`,
                        },
                    }
                );

                // Step 3: Update the state with the new array (remove the image locally)
                const updatedImages = operatorsImages.filter((image) => image !== selectedImage);
                setOperatorsImages(updatedImages);

                // Step 4: Close the modal
                setSelectedImage(null);

                // Show success message
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Photo deleted successfully",
                    confirmButtonText: "OK",
                });
            } catch (err) {
                console.error("Error deleting photo:", err);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An error occurred while deleting your photo. Please try again.",
                    confirmButtonText: "OK",
                });
            }
        }
    };




    return (
        <div className="slider-container profileSectionSlider">
            <Slider {...settings}>
                {operatorsImages?.flat().map((item, index) => (
                    <div key={index} className="operatorSliderImageOuter"
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img src={`${IMG_SERVER_URL}/${item}`} onClick={() => setSelectedImage(item)} className="operatorSliderImage" alt={`Operator Image ${index}`} />
                        <div className="crossIconContainer">
                            <RxCross2
                                className={`crossIcon ${hoveredIndex === index ? "visbleShow" : "visbleHidden"}`}
                                style={{ color: "red", fontSize: "20px" }}
                                onClick={(e) => DeletePhoto(e, item)}
                            />
                        </div>
                    </div>
                ))}
            </Slider>
            {selectedImage && (
                <div className="modal-overlay-profile" onClick={() => setSelectedImage(null)}>
                    <div className="modal-content-profile">
                        <img src={`${IMG_SERVER_URL}/${selectedImage}`} alt="Enlarged View" className="modal-content-profile-img" />
                        <button className="close-btn-profile" onClick={() => setSelectedImage(null)}>✖</button>
                        {/* <div className="deleteSection">
                            <button className="deletImageBtnOperat" onClick={DeletePhoto}>Delete</button>
                        </div> */}
                    </div>

                </div>
            )}
            <UploadOperatorImages updateOperatorsImages={updateOperatorsImages} />
        </div>
    )
}

export default OperatorPictursSlider
